import * as ReactDOM from "react-dom/client";
import WebApp from "./react/webApp";

ReactDOM.createRoot(document.getElementById('webApp')).render(WebApp());
